"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Marker = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var Marker = exports.Marker = _styledComponents["default"].div.withConfig({
  displayName: "HBMarkerstyles__Marker",
  componentId: "sc-1t9vnw7-0"
})(["position:absolute;right:0px;", " &:before{content:'';background-color:", ";display:block;font-size:16px;font-weight:bolder;color:white;text-align:center;width:25px;height:28px;line-height:22px;}&:after{content:'';display:block;width:0;height:0;position:absolute;top:0px;left:-11px;border-top:14px solid transparent;border-bottom:14px solid transparent;border-right:11px solid ", ";}"], function (props) {
  return props.color === _colors["default"].red50 ? 'z-index:1;' : '';
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
//# sourceMappingURL=HBMarker.styles.js.map